import React from "react";
import Pagination from "react-js-pagination";
import { ContentTable } from "./ContentTable";
import { BtnThemMoi } from "components/QuanLyNhanVien/QuanLyCongViec/ThemmoiSuaGiahanGiaoviec/BtnThemMoi";

export const TableDanhSach = ({ phanQuyen, listDanhSach, isLoading, dataSearch, setDataSearch, onSearch, onReload }) => {
    
    const handlePageChange = (pageNumber) => {
        const newSearchData = { ...dataSearch, pageIndex: pageNumber };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
    };

    return (
        <>
            {isLoading ? (
                <div className="loading-page1"><div className="loader loader-default is-active"></div></div>
            ) : (
                <>
                    <div className="card border-light mb-2 card-v2">
                        <div className="card-body card-body-v2">
                            <div className="row col-sm-12 col-md-12 themoi-taisanthly mb-1">
                                {phanQuyen.quanlycongviec_themcongviec && <BtnThemMoi onReload={onReload} />}
                            </div>
                            <div className="Left808x200 Table-main-new css-table-ds">
                                <div className="table-mobile table-mobile-hover">
                                    <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                                        <div className="table-headers" style={{alignItems: 'stretch'}}>
                                            <div className="custom-table-header text-center flex-basis-5 flex-basis-5-sm">
                                                <p className="color-do-bold">STT <br />[{listDanhSach.iTotal}]</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-12 flex-basis-12-sm">
                                                <p>Mã công việc</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-13 flex-basis-13-sm">
                                                <p>Nhân viên</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-15 flex-basis-15-sm">
                                                <p>Tên công việc</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-15 flex-basis-15-sm">
                                                <p>Liên quan đến hợp đồng</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm">
                                                <p>Thời hạn</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm">
                                                <p>Trạng thái</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm">
                                                <p>Đánh giá</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm">
                                                <p>Chức năng</p>
                                            </div>
                                        </div>
                                        <div className="custom-table-body">
                                            <ContentTable 
                                                listDanhSach={listDanhSach.List}
                                                phanQuyen={phanQuyen}
                                                onReload={onReload}
                                                dataSearch={dataSearch}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {listDanhSach.iTotal > 0 && (
                        <div className="card border-light mb-2 card-v2">
                            <div className="card-body card-body-v2">
                                <div className="row">
                                    <div className="col-sm-12 col-md-6">
                                        <span className="color7">
                                            Hiển thị {(dataSearch.pageIndex - 1) * dataSearch.pageSize + 1} - {Math.min(dataSearch.pageIndex * dataSearch.pageSize, listDanhSach.iTotal)} / Tổng số {listDanhSach.iTotal}
                                        </span>
                                    </div>
                                    <div className="col-sm-12 col-md-6">
                                        <div className="paniation-new paniation-new1 d-flex justify-content-end">
                                            <Pagination 
                                                activePage={dataSearch.pageIndex} 
                                                itemsCountPerPage={dataSearch.pageSize} 
                                                totalItemsCount={listDanhSach.iTotal} 
                                                pageRangeDisplayed={5} 
                                                onChange={handlePageChange} 
                                                itemClass="page-item border-none" 
                                                linkClass="page-link border-none" 
                                                activeClass="active" 
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
};